<template>
  <div class="tw-bg-gradient-to-t tw-from-[#0e0e10] tw-to-[#0d111b] tw-text-white">
    <div class="tw-container tw-mx-auto tw-px-10">
      <div class="tw-py-12">
        <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-5 tw-gap-8">
          <div class="tw-text-left tw-space-y-4">
            <strong class="tw-text-[#FAEBD7] tw-text-lg">Help</strong>
            <div class="tw-space-y-2 tw-text-[13px]">
              <div class="tw-cursor-pointer glow-hover" @click="openLink('https://2ez.bet/faq', '_blank', 'focus')">
                Frequently Asked Question (FAQ)
              </div>
              <div
                class="tw-cursor-pointer glow-hover"
                @click="openLink('https://www.facebook.com/groups/2ez.bet/', '_blank', 'focus')"
              >
                Join our Community
              </div>
              <div
                class="tw-cursor-pointer glow-hover"
                @click="openLink('https://2ez.bet/general-terms-and-conditions', '_blank', 'focus')"
              >
                General Terms & Conditions
              </div>
              <div
                class="tw-cursor-pointer glow-hover"
                @click="openLink('https://2ez.bet/responsible-gambling-policy', '_blank', 'focus')"
              >
                Responsible Gaming & Self Exclusion
              </div>
              <div
                class="tw-cursor-pointer glow-hover"
                @click="openLink('https://2ez.bet/kyc-policy', '_blank', 'focus')"
              >
                KYC Policy
              </div>
              <div
                class="tw-cursor-pointer glow-hover"
                @click="openLink('https://2ez.bet/privacy-policy', '_blank', 'focus')"
              >
                Privacy Policy
              </div>
            </div>
          </div>
          <div class="tw-text-left tw-space-y-4">
            <strong class="tw-text-[#FAEBD7] tw-text-lg">Contents</strong>
            <div class="tw-space-y-2 tw-text-[13px]">
              <div class="tw-cursor-pointer glow-hover" @click="openLink('https://2ez.bet/?t=esport_matches')">
                Esport Matches
              </div>
              <div class="tw-cursor-pointer glow-hover" @click="openLink('https://2ez.bet/?t=sport_matches')">
                Sport Matches
              </div>
              <div class="tw-cursor-pointer glow-hover" @click="openLink('https://2ez.bet/?t=tournament_matches')">
                Tournament Outright
              </div>
              <div class="tw-cursor-pointer glow-hover" @click="openLink('https://2ez.bet/market')">Market</div>
              <!-- <div class="tw-cursor-pointer glow-hover" @click="openLink('https://2ez.bet/')">Poker</div> -->
              <div class="tw-cursor-pointer glow-hover" @click="gotoHome">Casino</div>
            </div>
          </div>

          <div class="tw-text-left tw-space-y-4">
            <strong class="tw-text-[#FAEBD7] tw-text-lg">License</strong>
            <div class="tw-space-y-2 tw-text-[13px]">
              <div>&copy; Copyright March 2022 2ez.bet</div>
              <div>Gaming License No.365/JAZ</div>
              <div>All right reserved and protected by law.</div>
            </div>
          </div>
          <div class="tw-text-left tw-space-y-4">
            <strong class="tw-text-[#FAEBD7] tw-text-lg">Follow Us</strong>
            <div class="tw-space-y-2 tw-text-[13px]">
              <div>Visit the links below:</div>
              <div class="tw-flex tw-space-x-2">
                <span>
                  <v-btn @click="openLink('https://www.facebook.com/groups/114061875898337')" icon>
                    <v-icon large>mdi-facebook</v-icon>
                  </v-btn>
                </span>
                <span>
                  <v-btn @click="openLink('https://www.youtube.com/channel/UCbTPPtTXldnrvAnRQQn32Wg')" icon>
                    <v-icon large>mdi-youtube</v-icon>
                  </v-btn>
                </span>
              </div>
            </div>
          </div>
          <div class="tw-text-left tw-col-span-2 md:tw-col-span-1 tw-flex tw-justify-center md:tw-justify-start">
            <div>
              <strong class="tw-text-[#FAEBD7] tw-text-lg">Licensed By</strong>
              <div class="tw-space-y-2">
                <a
                  @click="
                    openLink(
                      'https://licensing.gaming-curacao.com/validator/?lh=5b91fc96ae93a4b048050f7b5e6925f7&fbclid=IwAR2sLiO_q320DVUqRF6RETwRuDbP2noyDQyUtwruE6F2eEyuGr063wED2ug',
                      '_blank',
                      'focus'
                    )
                  "
                >
                  <v-img width="150" :src="require('@/assets/images/licensed.svg')"></v-img>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-container fluid class="tw-bg-[#0d111b] tw-border-t tw-border-[#fff]">
      <v-row class="py-4">
        <v-col cols="12" class="tw-text-[#999] tw-space-y-2">
          <strong class="tw-text-[14px]">&copy; Copyright March 2022. All rights reserved.</strong>
          <div class="tw-text-[12px]">
            <div>
              The website and its services may not be used by users below the age of 18 years (or below the age of
              majority as stipulated in the laws of the jurisdictions applicable to them). Betting can be addictive.
              Please bet responsibly.
            </div>
            <div>Powered by 2ez.bet</div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  methods: {
    openLink(link, blank, focus = null) {
      if (focus) return window.open(link, blank).focus();
      return window.open(link, blank);
    },
    gotoHome() {
      location.href = process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/";
    },
  },
};
</script>

<style scoped>
.glow-hover:hover {
  text-shadow: 0px 0px 7px #fff;
}
</style>
